// extracted by mini-css-extract-plugin
export default {"nftText":"NftLand_nftText__ocUf5"};